// GENERATED FILE - DO NOT MODIFY
export enum ClientApplication {
    Mobile = "Mobile",
    Maestro = "Maestro",
}

export let nameof = "ClientApplication";
